import { coreApi } from 'services/api'

export const READ_MESSAGE = async (studentId: string, messageId: string) => {
  try {
    await coreApi.put(`/notifications/messages/student/${studentId}/message/${messageId}/read`)
  } catch (err) {
    console.log(err)
    throw err
  }
}
